<template>
    <sui-segment>
        <h3>
            {{ $t('gateway.processes.title', { gatewayId: gatewayProcessId }) }}
            <sui-label size="tiny">{{ listings.length }}</sui-label>
        </h3>
        <sui-table>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell>{{ $t('common.reference') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('gateway.processes.dbRef') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('common.pictures') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('common.outputFile') }}</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>
            
            <sui-table-body v-if="hasCurrentRunningProcess">
                <sui-table-row>
                    <sui-table-cell colspan="4" text-align="center">
                        {{ $t('gateway.processes.isRunning') }}
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>

            <sui-table-body v-else-if="listings.length > 0">
                <sui-table-row v-for="(listing, index) of listings"
                               :key="listing.hashed_reference"
                               :warning="listing.medias_uris.length === 1"
                               :title="listing.medias_uris.length === 1?$t('gateway.processes.listingsWithOneMedia'):''"
                >
                    <sui-table-cell>{{ listing.determined_id }}</sui-table-cell>
                    <sui-table-cell>{{ listing.hashed_reference }}</sui-table-cell>
                    <sui-table-cell>
                        <sui-button
                            :disabled="listing.medias_uris.length === 0"
                            @click="toggleShowPictures(index)"
                            fluid size="tiny"
                            v-if="!showPictures[index]"
                        >
                            {{ $t('gateway.processes.displayCount', { count: listing.medias_uris.length }) }}
                        </sui-button>
                        <a
                            v-else
                            v-for="uri of listing.medias_uris" :key="uri"
                            :href="getListingPictureURI(uri)"
                            target="_blank"
                        ><sui-image avatar :src="getListingPictureURI(uri)"/></a>
                    </sui-table-cell>
                    <sui-table-cell>
                        <sui-button fluid size="tiny" @click="openListingOutputFile(listing.content_uri)">
                            <sui-icon name="external alternate" /> Afficher
                        </sui-button>
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>

            <sui-table-body v-else>
                <sui-table-row>
                    <sui-table-cell colspan="4" text-align="center">
                        {{ $t('common.noData') }}
                    </sui-table-cell>
                </sui-table-row>
            </sui-table-body>
        </sui-table>
    </sui-segment>
</template>

<script>
export default {
    name: 'GatewayProcessListings',
    props: {
        listings: Array,
        gatewayProcessId: [String, Number],
        hasCurrentRunningProcess: Boolean,
    },
    data() {
        return {
            showPictures: [],
        }
    },
    methods: {
        toggleShowPictures(index) {
            this.showPictures[index] = true;
            this.showPictures = [...this.showPictures];
        },
        getListingPictureURI(uri) {
            return `${process.env.VUE_APP_STATIC_URL}${uri}`;
        },
        openListingOutputFile(uri) {
            window.open(`${process.env.VUE_APP_STATIC_URL}${uri}`, '_blank');
        },
    }
}
</script>
